import { Button, CssBaseline, Grid, Typography } from "@material-ui/core";
import MaterialTable from "material-table";
import LabelsContext from "../../../lang/LabelsContext";
import { tableIcons } from "../../system/material-table-utils/MaterialTableUtils";
import HtmlTooltip from "../../system/html-tooltip/HtmlTooltip";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import { usersTitle } from "../manuscript/submit/TooltipText";
import useStyles from "./AssociateEditorsStyle";
import { useHistory } from "react-router-dom";
import AssociateEditorsService, { AssociateEditorsServiceType } from "./AssociateEditorsService";

export default function AssociateEditors() {
  const { Labels } = LabelsContext();
  const classes = useStyles();
  const history = useHistory();
  const { users, loginAs }: AssociateEditorsServiceType = AssociateEditorsService();

  return (
    <>
      <CssBaseline />
      <MaterialTable
        data={users}
        icons={tableIcons}
        columns={[
          { field: "id", title: "ID", hidden: true },
          { field: "firstName", title: Labels.FIRSTNAME },
          { field: "lastName", title: Labels.LASTNAME },
          { field: "email", title: Labels.EMAIL_ADDRESS },
          { field: "country", title: Labels.COUNTRY },
          { field: "orcid", title: Labels.ORCID },
          { field: "group.group", title: Labels.ROLE },
          {
            field: "details",
            sorting: false,
            title: "",
            align: "right",
            render: (rowData) => (
              <Button variant="contained" onClick={() => history.push(`/user/edit/${rowData.id}`)} color="primary">
                {Labels.EDIT}
              </Button>
            ),
          },
          {
            field: "login",
            sorting: false,
            title: "",
            render: (rowData) => (
              <Button variant="contained" onClick={() => loginAs(rowData.id)} color="primary">
                {Labels.LOGIN_AS}
              </Button>
            ),
          },
        ]}
        title={
          <div className={classes.addReviewerContainer}>
            <Grid container justify="space-evenly">
              <Typography variant="h5">{Labels.USERS}</Typography>
              <HtmlTooltip title={usersTitle}>
                <HelpOutlineIcon fontSize="small" className={classes.helpIcon} />
              </HtmlTooltip>
            </Grid>
          </div>
        }
        options={{
          actionsColumnIndex: -1,
          pageSize: 10,
          pageSizeOptions: [10, 50, 100, users?.length > 100 ? users.length : 1000],
        }}
      />
    </>
  );
}
